const registerTypeMap = {
  '00': '来店ポイント',
  '01': '幹事ポイント',
}

export default registerTypeMap

// 幹事ポイント対象
export function isOrganizerPoint(registerPointType) {
  return registerPointType === '01'
}
